import type {AboutYouDetails} from '@nib/types-session-api';
import {ARHIJoinState} from '../../rootReducer';
import _get from 'lodash/get';

export const selectData = (state: ARHIJoinState): AboutYouDetails => _get(state, 'session.session.aboutYouDetails') || ({} as AboutYouDetails);

export const getHasCompletedAboutYou = (state: ARHIJoinState) => selectData(state).hasCompletedAboutYou;
export const getVisitorType = (state: ARHIJoinState) => selectData(state).visitorType;
export const getAllowLeadsContact = (state: ARHIJoinState) => selectData(state).allowLeadsContact;
